import { ANIMATE } from '@namespace/top/animate'

export default function top() {
  window.addEventListener('load', () => {
    const body = document.querySelector('body')

    if (body.classList.contains('home')) {
      ANIMATE.init()
    }
  })
}
